export class IllegalArgumentError extends Error {

    constructor(name: string, value: any) {
        super(`Illegal argument error: [${name}]=[${value}]`);
    }
}
